import { ref } from 'vue'
import { useApi } from '@/composables/api'
import { useStorage } from '@/composables/storage'

const settings = ref(null)
const isLoading = ref(false)

export function useSettings() {
    const storage = useStorage()

    async function loadSettings(force = false) {
        // Если уже загружаем или загрузили (и не принудительно), ничего не делаем
        if (isLoading.value || (!force && settings.value)) {
            return;
        }

        isLoading.value = true;

        if (!force) {
            // Сначала пытаемся быстро загрузить из localStorage
            const storedSettings = storage.getJson('settings');
            if (storedSettings) {
                settings.value = storedSettings;
            }
        }

        // Затем запрашиваем свежие данные с API
        const { data: apiData } = await useApi(true, 'index', 'settings');

        if (apiData.value) {
            // Преобразуем массив настроек в удобный объект: { delivery_methods: [...], ... }
            const settingsObject = apiData.value.reduce((acc, item) => {
                acc[item.key] = item.options;
                return acc;
            }, {});

            settings.value = settingsObject;
            storage.setJson('settings', settingsObject); // Сохраняем в localStorage
        }

        isLoading.value = false;
    }

    // Простая функция для получения конкретной настройки
    function getSetting(key) {
        return settings.value ? settings.value[key] : [];
    }

    return {
        settings,
        isLoading,
        loadSettings,
        getSetting
    }
}